import { TFunction } from 'i18next';

import { Currency } from '../../../../reference/Currency';
import { ShippingMethod } from '../ShippingMethodSelectionStore';

function getEstimateLabel(estimate: string) {
  if (estimate === '1') {
    return 'ShipMethDeliveryEstimateDay';
  }
  return 'ShipMethDeliveryEstimateDays';
}

export function getShippingMethodLabel(shipping: ShippingMethod, t: TFunction, currency: Currency) {
  function getEstimate(estimate: string) {
    if (!estimate || estimate === 'None') {
      return '';
    }
    const label = getEstimateLabel(estimate);
    return `(${estimate} ${t(label)})`;
  }

  return `${shipping.name} ${currency.symbol}${currency.formatDisplayAmount(shipping.rate)} ${getEstimate(
    shipping.estimatedDelivery
  )}`;
}
